/*运营管理*/

import {axiospost, axiosget,axiosgetExcel} from './axios';

//运营管理--活动列表分页
export const getEventPageList = (params) => axiosget('/sys/operationManagement/getEventPageList', params)
//运营管理--添加活动
export const addAntEvent = (params) => axiospost('/sys/operationManagement/addAntEvent', params)
//运营管理--修改活动发布状态（传值主键即可）
export const updatePostStatus = (params) => axiosget('/sys/operationManagement/updatePostStatus', params)
//运营管理--活动详情
export const getAntEventById = (params) => axiosget('/sys/operationManagement/getAntEventById', params)
//运营管理--修改活动
export const updateAntEvent = (params) => axiospost('/sys/operationManagement/updateAntEvent', params)
//运营管理--删除活动
export const deleteAntEvent = (params) => axiospost('/sys/operationManagement/deleteAntEvent', params)
//运营管理--活动下拉
export const getAntEventForSelect = (params) => axiosget('/sys/operationManagement/getAntEventForSelect', params)
//运营管理--根据赛事id获取比赛排行榜
export const getGameListTop10Page = (params) => axiosget('/sys/operationManagement/getGameListTop10Page', params)


//运营管理--查询勋章列表
export const getMedalListPage = (params) => axiosget('/sys/operationManagement/getMedalListPage', params)
//运营管理--查询勋章详情
export const getMedalById = (params) => axiosget('/sys/operationManagement/getMedalById', params)
//运营管理--添加勋章
export const addMedal = (params) => axiospost('/sys/operationManagement/addMedal', params)
//运营管理--勋章编辑
export const updateMedal = (params) => axiospost('/sys/operationManagement/updateMedal', params)
// 获取勋章分类数据字典
export const competitionType = () => axiosget('/sys/dict/getDictItems/competition_type')
// 获取勋章分条件据字典
export const medalGetType = () => axiosget('/sys/dict/getDictItems/medal_get_type')

//运营管理--查询段位列表
export const getRankPage = (params) => axiosget('/sys/operationManagement/getRankPage', params)
//运营管理--添加段位
export const addRankInfo = (params) => axiospost('/sys/operationManagement/addRankInfo', params)
//运营管理--修改段位
export const updateRankInfo = (params) => axiospost('/sys/operationManagement/updateRankInfo', params)

//运营管理--日榜列表(没有分页,没有getByid列表上都有)
export const getRankingListDayPage = (params) => axiosget('/sys/operationManagement/getRankingListDayPage', params)
//运营管理--编辑奖励
export const updatePointAward = (params) => axiospost('/sys/operationManagement/updatePointAward', params)

//运营管理--赛事列表
export const getGamePageList = (params) => axiosget('/sys/operationManagement/getGamePageList', params)
//运营管理--获取赛事详情
export const getGameInfo = (params) => axiosget('/sys/operationManagement/getGameInfo', params)
//运营管理--编辑赛事
export const updateGameInfo = (params) => axiospost('/sys/operationManagement/updateGameInfo', params)
//运营管理--添加赛事
export const addGameInfo = (params) => axiospost('/sys/operationManagement/addGameInfo', params)
// 获取每组箭支字典
export const groupArrow = () => axiosget('/sys/dict/getDictItems/group_arrow')
// 获取弓种字典（3种）
export const bowType = () => axiosget('/sys/dict/getDictItems/bow_type')
// 获取弓种字典（5种）
export const bowTypes = () => axiosget('/sys/dict/getDictItems/archery_book_bow_species')
//获取组数字典
export const groupCountType = () => axiosget('/sys/dict/getDictItems/group_count_type')
//获取米数字典
export const meterType = () => axiosget('/sys/dict/getDictItems/meter_type')
//比赛米数字典
export const gameMeter = () => axiosget('/sys/dict/getDictItems/game_meter')
//获取靶纸字典
export const targetSheet = () => axiosget('/sys/dict/getDictItems/target_sheet')

//运营管理--查询活动报名列表
export const getEventSignPage = (params) => axiosget('/sys/operationManagement/getEventSignPage', params)
//运营管理--活动报名导出
export const getEventSignForExcel = (params) => axiosgetExcel('/sys/operationManagement/getEventSignForExcel', params)

//运营管理--组王榜
export const getGroupKingRanking = (params) => axiosget('/sys/operationManagement/getGroupKingRanking', params)
//运营管理--组王榜修改组王榜组数
export const updateGroupKingRankingGroupCount = (params) => axiospost('/sys/operationManagement/updateGroupKingRankingGroupCount', params)
//运营管理--组王榜导出
export const getGroupKingRankingForExcel = (params) => axiosgetExcel('/sys/operationManagement/getGroupKingRankingForExcel', params)



//运营管理--日榜下拉列表(榜单)
export const getRankingListForSelect = (params) => axiosget('/sys/operationManagement/getRankingListForSelect', params)
//运营管理--日赛排行榜
export const getAntRankingListDayScoreList = (params) => axiosget('/sys/operationManagement/getAntRankingListDayScoreList', params)
//运营管理--日赛排行榜，榜单详情
export const getAntRankingListDayScoreDetail = (params) => axiosget('/sys/operationManagement/getAntRankingListDayScoreDetail', params)
// 运营管理--日榜导出
export const getAntRankingListDayScoreListForExcel = (params) => axiosgetExcel('/sys/operationManagement/getAntRankingListDayScoreListForExcel', params)


// 订单管理--获取自定义项列表
// export const getOrderCustomizationList = () => axiosget('/sys/orderManagement/getOrderCustomizationList')
//订单管理--添加订单自定义项
export const addOrderCustomization = (params) => axiospost('/sys/orderManagement/addOrderCustomization',params)
//订单管理--自定义项修改名称
export const updateAntOrderCustomName = (params) => axiospost('/sys/orderManagement/updateAntOrderCustomName',params)
//订单管理--获取自定义项列表分页
export const getOrderCustomizationPage = (params) => axiosget('/sys/orderManagement/getOrderCustomizationPage',params)


// 查询成绩列表
export const getAntMembersScorePage = (params) => axiosget('/sys/orderManagement/getAntMembersScorePage',params)
// 查询比赛成绩列表
export const getGameScorePage = (params) => axiosget('/sys/orderManagement/getGameScorePage',params)


// 赛事管理导出
export const getGamePageListForExcel = (params) => axiosgetExcel('/sys/operationManagement/getGamePageListForExcel',params)